import { useState } from "react";
import { FAQS } from "@/mocks/gossip";

export default function Faq() {
  const [open, setOpen] = useState<number>(0);
  return (
    <section id="faq" className="bg-paper-50 py-12 md:py-20 scroll-mt-24">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <p className="text-sm font-semibold text-brand-600 mb-2 kicker-line">先弄明白再开追</p>
            <h2 className="font-heading font-black text-3xl md:text-4xl text-ink-900">热瓜问答</h2>
            <p className="mt-4 text-base text-ink-600 leading-relaxed">
              关于状态标签、"更新到最新"的标准，以及你的追瓜记录，这里都有答案。没覆盖到的问题，欢迎随时找编辑部聊聊。
            </p>
            <div className="mt-6 rounded-2xl bg-paper-100 border border-ink-200/60 p-5 flex items-center gap-4">
              <span className="w-11 h-11 shrink-0 rounded-full bg-brand-500 text-paper-50 flex items-center justify-center">
                <i className="ri-mail-send-line text-xl" />
              </span>
              <div>
                <p className="font-semibold text-ink-900 text-sm">想反馈或提建议？</p>
                <p className="text-xs text-ink-500 mt-0.5">邮件我们：contact@jinriregua.top</p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 space-y-3">
            {FAQS.map((f, i) => {
              const isOpen = open === i;
              return (
                <div
                  key={i}
                  className={`rounded-xl border transition-colors overflow-hidden ${
                    isOpen ? "border-brand-300 bg-brand-50/60" : "border-ink-200/70 bg-paper-50"
                  }`}
                >
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    className="w-full flex items-center gap-3 px-5 py-4 text-left"
                  >
                    <span
                      className={`shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-sm ${
                        isOpen ? "bg-brand-500 text-paper-50" : "bg-paper-100 text-ink-500 border border-ink-200"
                      }`}
                    >
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="flex-1 font-semibold text-ink-900 text-[15px]">{f.q}</span>
                    <i
                      className={`ri-arrow-down-s-line text-ink-400 text-xl transition-transform ${isOpen ? "rotate-180 text-brand-500" : ""}`}
                    />
                  </button>
                  <div className={`grid transition-all duration-300 ${isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}>
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 pl-[60px] text-sm text-ink-600 leading-relaxed">{f.a}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}